export default __webpack_public_path__ + "1810b847ee7f594d256c5ff366733f21.png";